import React, { useState } from 'react';
import { FaBug } from 'react-icons/fa';
import { ButtonFilled } from '../Button/Button';
import './BugPanel.scss';
import { postData } from '../../utils/utils';

function BugPanel() {
  /* State to toggle form */
  const [show, setShow] = useState(false);

  /* Fields useState */
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmitForm = async () => {
    if (subject.length < 1) {
      alert('Please include a subject');
    } else if (description.length < 1) {
      alert('Please include a description');
    } else {
      const body = {
        subject,
        description,
      };
      const response = await postData('/issues', body);
      if (response.status === 201) {
        alert('Successfully submitted!');
        setShow(false);
      } else {
        alert(`Failed to submit issue: ${response.data}`);
        setShow(false);
      }
    }
  };

  return (
    <div>
      {
        /* Toggle form */
        show ? (
          <div className="panel-wrapper">
            <div className="main-header">
              <div className="main-title">Report an Issue</div>
            </div>
            <div className="main-form">
              <div>
                <div className="main-text">
                  We're sorry our software isn't working for you. We'll resolve
                  this issue as soon as we can.
                </div>
                <div className="input-label">Subject</div>
                <input
                  className="subject-input"
                  type="text"
                  onChange={(e) => setSubject(e.target.value)}
                />
                <div className="input-label">Description</div>
                <textarea
                  className="description-input"
                  onChange={(e) => setDescription(e.target.value)}
                />

                <div className="loginBtn">
                  <ButtonFilled handleSubmit={handleSubmitForm}>
                    Submit
                  </ButtonFilled>
                </div>
              </div>
            </div>
          </div>
        ) : null
      }

      {/* Bug Icon to toggle form using setShow */}
      <div>
        <button
          type="button"
          className="icon-btn"
          onClick={() => {
            setShow(!show);
            setSubject('');
            setDescription('');
          }}
        >
          {' '}
          <FaBug size={30} className="icon-style" />
          {' '}
        </button>
      </div>
    </div>
  );
}

export default BugPanel;
